import { Pipe, PipeTransform } from '@angular/core';
import { EThemeName, ThemeService } from '@wind-log_library/fe-component-library';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { NAVIGATION_ICONS } from './navigation-icons.constant';

@Pipe({
    name: 'imageSrc',
    standalone: false
})
export class ImageSrcDependsOnThemePipe implements PipeTransform {
  private iconList = [
    {
      key: 'legendMaintenance',
      [EThemeName.LIGHT]: 'assets/monitor/portfolio/power-forecast/non-working-hours-icon-light.svg',
      [EThemeName.DARK]: 'assets/monitor/portfolio/power-forecast/non-working-hours-icon-dark.svg'
    },
    {
      key: 'countryLocation',
      [EThemeName.LIGHT]: 'assets/search/country_location.svg',
      [EThemeName.DARK]: 'assets/search/country_location_light.svg'
    },
    {
      key: 'ratedPower',
      [EThemeName.LIGHT]: 'assets/park-monitor/parkview-modal/RatedPower-Icon-DarkBlue.svg',
      [EThemeName.DARK]: 'assets/park-monitor/parkview-modal/RatedPower-Icon-White.svg'
    },
    {
      key: 'estAnnualProduction',
      [EThemeName.LIGHT]: 'assets/park-monitor/parkview-modal/EstAnnualProduction-Icon-DarkBlue.svg',
      [EThemeName.DARK]: 'assets/park-monitor/parkview-modal/EstAnnualProduction-Icon-White.svg'
    },
    {
      key: 'commissioned',
      [EThemeName.LIGHT]: 'assets/park-monitor/parkview-modal/Commissioned-Icon-DarkBlue.svg',
      [EThemeName.DARK]: 'assets/park-monitor/parkview-modal/Commissioned-Icon-White.svg'
    },
    {
      key: 'icon-tableview',
      [EThemeName.LIGHT]: `${environment.shared_server}/general/main-interface/icon-tableview-light.svg`,
      [EThemeName.DARK]: `${environment.shared_server}/general/main-interface/icon-tableview-dark.svg`
    },
    {
      key: 'icon-chartview',
      [EThemeName.LIGHT]: `${environment.shared_server}/general/main-interface/icon-chartview-light.svg`,
      [EThemeName.DARK]: `${environment.shared_server}/general/main-interface/icon-chartview-dark.svg`
    },
    {
      key: 'mergeUp', 
      [EThemeName.LIGHT]: 'assets/images/sort-size/sort-size-up-dark.svg',
      [EThemeName.DARK]: 'assets/images/sort-size/sort-size-up-light.svg'
    },
    {
      key: 'mergeDown', 
      [EThemeName.LIGHT]: 'assets/images/sort-size/sort-size-down-dark.svg',
      [EThemeName.DARK]: 'assets/images/sort-size/sort-size-down-light.svg'
    },
    {
      key: 'pin', 
      [EThemeName.LIGHT]: 'assets/images/pin/pin-dark.svg',
      [EThemeName.DARK]: 'assets/images/pin/pin-light.svg'
    },
    {
      key: 'pinned', 
      [EThemeName.LIGHT]: 'assets/images/pin/pinned-dark.svg',
      [EThemeName.DARK]: 'assets/images/pin/pinned-light.svg'
    },
    {
      key: 'alarmsLinkIcon', 
      [EThemeName.LIGHT]: 'assets/troubleshoot/Icon-AlarmsLink-DarkBlue.svg',
      [EThemeName.DARK]: 'assets/troubleshoot/Icon-AlarmsLink-White.svg'
    },
    ...NAVIGATION_ICONS
  ];

  constructor(private themeService: ThemeService) {
  }

  public transform(iconKey: string): Observable<string> {
    return this.themeService.getTheme().pipe(
      map((name: EThemeName) => {
        const icon = this.iconList.find(i => i.key === iconKey);
        return icon ? icon[name] : '';
      })
    );
  }
}
